import { services as s } from "@/services";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { supabaseClient } from "../../../lib/supabase";
import type { Template } from "../../../types/database/diaries";

export const useUpdateTemplate = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (data: {
			template_id: string;
			formData: Template["Update"];
		}) => {
			const { template_id, formData } = data;
			const { data: updatedTemplate, error } = await supabaseClient
				.from("templates")
				.update(formData)
				.eq("template_id", template_id)
				.select()
				.single();

			if (error) throw error;
			return updatedTemplate;
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["templates"] });
			toast.success("Template updated successfully");
		},
		onError: (error) => {
			console.error("Error updating template:", error);
			toast.error("Failed to update template");
		},
	});
};
